<template>
  <v-container>
    <v-simple-table fixed-header class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Nombre</th>
            <th class="text-left">Ley</th>
            <th class="text-left">Reglamento</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in docs" :key="doc.name">
            <td>{{ doc.name }}</td>
            <td>
              <v-btn
                v-if="doc.ley"
                :href="doc.ley"
                target="_blank"
                text
                color="accent"
              >
                <span class="mr-2">Ver</span>
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                v-if="doc.reglamento"
                :href="doc.reglamento"
                target="_blank"
                text
                color="accent"
              >
                <span class="mr-2">Ver</span>
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      docs: [
        {
          name: "Ley del Notariado de Chihiahua",
          ley: "http://www.testamentos.gob.mx/Documentos/leyesnot/8leynot.pdf",
        },
        {
          name: "Código de Procedimientos Civiles",
          ley:
            "http://www.congresochihuahua2.gob.mx/biblioteca/codigos/archivosCodigos/62.pdf",
        },
        {
          name: "Código de Procedimientos Familiares",
          ley:
            "http://www.congresochihuahua2.gob.mx/biblioteca/codigos/archivosCodigos/63.pdf",
        },
        {
          name: "Ley del Impuesto Sobre la Renta",
          ley: "http://www.diputados.gob.mx/LeyesBiblio/pdf/LISR_091219.pdf",
          reglamento:
            "http://www.diputados.gob.mx/LeyesBiblio/regley/Reg_LISR_060516.pdf",
        },
        {
          name: "Ley Agraria",
          ley: "http://www.diputados.gob.mx/LeyesBiblio/pdf/13_250618.pdf",
        },
        {
          name: "Código Fiscal de la Federación",
          ley: "http://www.diputados.gob.mx/LeyesBiblio/pdf/8_090120.pdf",
        },
        {
          name: "Código Municipal para el Estado de Chihuahua",
          ley:
            "http://www.congresochihuahua2.gob.mx/biblioteca/codigos/archivosCodigos/19.pdf",
        },
        {
          name: "Ley del Impuesto al Valor Agregado",
          ley: "http://www.diputados.gob.mx/LeyesBiblio/pdf/77_091219.pdf",
          reglamento:
            "http://www.diputados.gob.mx/LeyesBiblio/regley/Reg_LIVA_250914.pdf",
        },
        {
          name: "Ley de Hacienda del Estado de Chihuahua",
          ley:
            "http://www.congresochihuahua2.gob.mx/biblioteca/leyes/archivosLeyes/1442.pdf",
        },
        {
          name:
            "Ley de Prevención e Identificación de Operaciones con Recursos de Procedencia Ilicita",
          reglamento:
            "http://www.diputados.gob.mx/LeyesBiblio/regley/Reg_LFPIORPI.pdf",
          ley:
            "http://www.diputados.gob.mx/LeyesBiblio/pdf/LFPIORPI_090318.pdf",
        },
        {
          name: "Leyes de Ingresos del Gobierno del Estado de Chihuahua",
          ley: `${process.env.BASE_URL}pdfs/ley_ingresos.pdf`,
        },
        {
          name: "Leyes de Ingresos del Municipio de Chihuahua",
          ley: `${process.env.BASE_URL}pdfs/ley_ingresos.pdf`,
        },
      ],
    };
  },
  methods: {
    internalClick(pdf) {
      console.log("open window");
      window.open(pdf);
    },
  },
};
</script>

<style>
</style>